import { buildStateEvent, GenericStateEvent } from '../../../common-redux'
import { Asset } from './model'

export interface AssetStateEvent<T> extends GenericStateEvent<T> {}

export const GetAllAssetSuccessEvent = {
    type: 'GetAllAssetSuccessEvent',
    build: (payload: Asset[]) => buildStateEvent(GetAllAssetSuccessEvent.type, payload)
}

export const AddAssetSuccessEvent = {
    type: 'AddAssetSuccessEvent',
    build: (payload: Asset) => buildStateEvent(AddAssetSuccessEvent.type, payload)
}

export const DeleteAssetSuccessEvent = {
    type: 'DeleteAssetSuccessEvent',
    build: (payload: string) => buildStateEvent(DeleteAssetSuccessEvent.type, payload)
}

export const UpdateAssetSuccessEvent = {
    type: 'UpdateAssetSuccessEvent',
    build: (payload: Asset) => buildStateEvent(UpdateAssetSuccessEvent.type, payload)
}
